const LOG_LEVELS = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
};

const getCurrentLogLevel = () => {
    const configuredLevel = (process.env.REACT_APP_LOG_LEVEL || '').toLowerCase();
    if (Object.prototype.hasOwnProperty.call(LOG_LEVELS, configuredLevel)) {
        return LOG_LEVELS[configuredLevel];
    }
    return process.env.NODE_ENV === 'development' ? LOG_LEVELS.debug : LOG_LEVELS.warn;
};

const shouldLog = (level) => LOG_LEVELS[level] <= getCurrentLogLevel();

const write = (level, args) => {
    if (!shouldLog(level)) return;
    const method = typeof console[level] === 'function' ? level : 'log';
    console[method](...args);
};

const logger = {
    error: (...args) => write('error', args),
    warn: (...args) => write('warn', args),
    info: (...args) => write('info', args),
    debug: (...args) => write('debug', args),
};

export default logger;
